import GlobalWarningModal from './GlobalWarningModal';

export default GlobalWarningModal;
